define('../app/fukit/configuration/backbone.history.configuration',['require','exports','module','backbone'],function(require, exports, module) {
  var Backbone = require('backbone');

  var HistoryConfiguration = {
    radioEvents: {
      'app ready': 'onAppReady',
    },

    onAppReady: function() {
      // start routing
      Backbone.history.start();
    },
  };

  module.exports = HistoryConfiguration;
});

